import CopilotActionButton from 'ai-components-ui-library/components/buttons/CopilotActionButton';
import UsageTracker from '../../../utils/UsageTracker';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotActionButtonWrapper = styledWithTheme.span(({
  theme
}) => ({
  span: {
    background: 'transparent !important'
  },
  button: {
    marginInlineStart: theme.space['400'],
    borderRadius: `${theme.borderRadius['200']} !important`,
    padding: `${theme.space['200']} !important`,
    transition: 'none !important',
    background: 'transparent !important',
    fontWeight: '400 !important',
    border: 'none !important',
    color: '#fbdbe9 !important',
    '&:hover': {
      backgroundColor: `${theme.color['do-not-use-heffalump']} !important`,
      color: `${theme.color['do-not-use-olaf']} !important`
    }
  }
}));
const CopilotNavLaunchButton = () => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(CopilotActionButtonWrapper, {
      children: /*#__PURE__*/_jsx(CopilotActionButton, {
        copilotAction: {
          openPromptTemplate: {
            id: 'ask_hubspot_academy'
          }
        },
        text: "Copilot",
        usageTracker: UsageTracker.tracker,
        usageTrackerAppLocationKey: "academy:navigation:ask-hubspot-academy",
        use: "tertiary"
      })
    })
  );
};
export default CopilotNavLaunchButton;